import {AnyEvent, JOB_SECTION_ITEM_CREATED, JobSectionItemCreatedEvent} from '../type';

export default function jobSectionItemCreated(payload: JobSectionItemCreatedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_ITEM_CREATED,
    payload,
  }
}